<template>

<p v-html="text"/>

</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    text: String
  }
}
</script>

<style lang="scss" scoped>
p {
  font-size: 48px;
  text-align: left;
  font-family: 'HelveticaNeueLTPro-HvEx';
  font-weight: bold;
  line-height: 1.19;
  margin-bottom: 40px;
}

@media (max-width: 550px), (max-device-width: 550px) {
  p {
    font-size: 36px;
  }
}
</style>
